import React from 'react'
import { Row, Col, Button, FormControl } from 'react-bootstrap'
import i18next from 'i18next'
import { List } from 'immutable'

import GridContainer from './GridContainer'
import GroupDriversSelection from './GroupDriversSelection'
import WopiListProfile from './WopiListProfile'
import Paginator from './Paginator'
import Loading from './Loading'

import listingStyles from './styles/listing.scss'
import searchIcon from './../assets/images/search.png'

export default class GroupDriversComparison extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keyword: '',
      selectedProfiles: List(),
      language: props.currentLanguage
    }
  }

  componentDidMount() {
    this.props.onSearch(this.props.currentOrganisationId, null, {}, 1, false)
  }

  toggleSelection = profile => () => {
    const { selectedProfiles } = this.state

    const existing = selectedProfiles.find(p => p.uuid == profile.uuid)

    if (existing) {
      return this.setState({
        selectedProfiles: selectedProfiles.delete(selectedProfiles.indexOf(existing))
      })
    }

    this.setState({ selectedProfiles: selectedProfiles.push(profile) })
  }

  isSelected = profile => {
    return this.state.selectedProfiles.find(p => p.uuid == profile.uuid)
  }

  onSearch = e => {
    e.preventDefault()

    this.props.onSearch(this.props.currentOrganisationId, this.state.keyword, {}, 1, false)
  }

  render() {
    const { questionnaires, searchFilters, pagination, token, currentOrganisationId } = this.props

    const currentLanguage = this.state.language

    return (
      <GridContainer>
        <Row>
          <Col md={8} lg={8}>
            <Row>
              <Col md={12}>
                <header>
                  <h1>{i18next.t('group_drivers')}</h1>
                </header>
              </Col>
            </Row>

            <Row>
              <Col md={12} className={listingStyles.filters}>
                <Row>
                  <Col md={6} lg={7} style={{ marginBottom: 15 }}>
                    {i18next.t('wopi_profiles')}
                  </Col>

                  <Col md={6} lg={5}>
                    <form onSubmit={this.onSearch} style={{ position: 'relative' }}>
                      <FormControl
                        type="text"
                        className={listingStyles.search}
                        placeholder={i18next.t('search_for_questionnaires')}
                        value={this.state.keyword}
                        onChange={e => this.setState({ keyword: e.target.value })}
                      />
                      <Button className={listingStyles.searchIcon} onClick={this.onSearch}>
                        <img src={searchIcon} />
                      </Button>
                    </form>
                  </Col>
                </Row>
              </Col>
            </Row>

            {!questionnaires && <Loading inline={true} />}

            {questionnaires && (
              <div>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'center', width: 80 }}>{i18next.t('select')}</th>
                        <th style={{ width: 140 }}>{i18next.t('date')}</th>
                        <th>{i18next.t('respondent')}</th>
                        <th>{i18next.t('organisation_and_role')}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {questionnaires.count() > 0 &&
                        questionnaires.map(profile => {
                          return (
                            <WopiListProfile
                              key={profile.uuid}
                              questionnaire={profile}
                              isSelected={this.isSelected(profile)}
                              hideDuration={true}
                              onToggleSelection={this.toggleSelection(profile)}
                            />
                          )
                        })}

                      {questionnaires.count() === 0 && (
                        <tr>
                          <td colSpan={10}>{i18next.t('no_results')}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {pagination && (
                  <Paginator
                    totalCount={pagination.totalCount}
                    page={pagination.page}
                    limit={pagination.limit}
                    onPaginate={page =>
                      this.props.onSearch(
                        this.props.currentOrganisationId,
                        this.state.keyword,
                        searchFilters,
                        page,
                        false
                      )
                    }
                  />
                )}
              </div>
            )}
          </Col>

          <Col md={4} lg={4}>
            <GroupDriversSelection
              selectedProfiles={this.state.selectedProfiles}
              language={currentLanguage}
              onToggleSelection={this.toggleSelection}
              token={token}
              currentOrganisationId={currentOrganisationId}
            />
          </Col>
        </Row>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GroupDriversComparison.js